
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[catalogInstance]/services/[id]",
      function () {
        return require("private-next-pages/c/[catalogInstance]/services/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[catalogInstance]/services/[id]"])
      });
    }
  